import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import BannerImg from '../../assets/images/banner.jpg'
import LandingImg from '../../assets/images/landing2.webp'
import styles from './Blog.module.scss'

const blogPosts = [
  {
    id: 1,
    slug: '/blog/chauffeur-rides-ltd-redefining-luxury-chauffeur-service-london',
    title: 'Chauffeur Rides Ltd – Redefining Luxury Chauffeur Service in London',
    excerpt:
      'When you are in a city like London, everything is moving fast, so you really need a way to get around that you can count on and that also looks nice. Chauffeur Rides Ltd is the company that can do this for you...',
    image: BannerImg,
    date: 'March 5, 2026',
  },
  {
    id: 2,
    slug: '/blog/premium-chauffeur-rides-london-travel-comfort-style',
    title: 'Premium Chauffeur Rides London – Travel in Comfort and Style',
    excerpt:
      "When you're thinking of getting a luxury ride in London, Premium Chauffeur Rides London is the way to go. They have nice cars and very professional drivers...",
    image: LandingImg,
    date: 'March 8, 2026',
  },
]

const Blog = () => {
  return (
    <div className={styles.blog}>
      <Helmet>
        <title>Chauffeur Service Blog | Luxury Travel Insights London</title>
        <meta
          name="description"
          content="Read expert insights on luxury chauffeur services, airport transfers, corporate travel and London day trips. Travel tips, updates & industry news."
        />
      </Helmet>

      <div className={styles.blog__header}>
        <h1>Our Blogs</h1>
        <p>Expert insights on luxury chauffeur services, travel tips and industry news</p>
      </div>

      <div className={styles.blogGrid}>
        {blogPosts.map(post => (
          <Link to={post.slug} key={post.id} className={styles.blogCard}>
            <div className={styles.blogCard__image}>
              <img src={post.image} alt={post.title} />
            </div>
            <div className={styles.blogCard__body}>
              <span className={styles.blogCard__date}>{post.date}</span>
              <h2 className={styles.blogCard__title}>{post.title}</h2>
              <p className={styles.blogCard__excerpt}>{post.excerpt}</p>
              <span className={styles.blogCard__readMore}>Read More &rarr;</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
export default Blog
